import { Component, OnInit, Input } from '@angular/core';
import { SaleExportData } from '../../models/sale-export-data';

@Component({
  selector: 'app-sale-export',
  templateUrl: './sale-export.component.html',
  styleUrls: ['sale-export.css']
})
export class SaleExportComponent implements OnInit {

  @Input() saleExportData: SaleExportData;
  @Input() showPrice: boolean;
  
  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/venta/sale-export/sale-export.component.ts